import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';

import { ExternalLink, NamedLink } from '../../../components';

export const SHOPIFY_HOME_URL = 'https://darkgloomyart.com';

export const DARK_GLOOMY_NAVIGATION = [
  {
    id: 'home',
    messageId: 'TopbarNavigation.home',
    href: SHOPIFY_HOME_URL,
  },
  {
    id: 'marketplace',
    messageId: 'TopbarNavigation.marketplace',
    children: [
      {
        id: 'browse',
        messageId: 'TopbarNavigation.browseArtworks',
        routeName: 'SearchPage',
      },
      {
        id: 'artists',
        messageId: 'TopbarNavigation.meetTheArtists',
        href: `${SHOPIFY_HOME_URL}/pages/artists`,
      },
      {
        id: 'sell',
        messageId: 'TopbarNavigation.sellYourArt',
        routeName: 'NewListingPage',
      },
      {
        id: 'buying-guide',
        messageId: 'TopbarNavigation.buyingGuide',
        routeName: 'CMSPage',
        params: { pageId: 'buying-on-dark-gloomy-art' },
      },
      {
        id: 'selling-guide',
        messageId: 'TopbarNavigation.sellingGuide',
        routeName: 'CMSPage',
        params: { pageId: 'selling-on-dark-gloomy-art' },
      },
    ],
  },
  {
    id: 'shop',
    messageId: 'TopbarNavigation.shop',
    children: [
      {
        id: 'fine-art-prints',
        messageId: 'TopbarNavigation.fineArtPrints',
        href: `${SHOPIFY_HOME_URL}/collections/prints`,
      },
      {
        id: 'framed-prints',
        messageId: 'TopbarNavigation.framedPrints',
        href: `${SHOPIFY_HOME_URL}/collections/framed`,
      },
      {
        id: 'books',
        messageId: 'TopbarNavigation.books',
        href: `${SHOPIFY_HOME_URL}/collections/books`,
      },
      {
        id: 'phone-cases',
        messageId: 'TopbarNavigation.phoneCases',
        href: `${SHOPIFY_HOME_URL}/collections/phone-cases`,
      },
    ],
  },
  {
    id: 'blog',
    messageId: 'TopbarNavigation.blog',
    href: `${SHOPIFY_HOME_URL}/blogs/articles`,
  },
  {
    id: 'about',
    messageId: 'TopbarNavigation.aboutUs',
    href: `${SHOPIFY_HOME_URL}/pages/about-us`,
  },
];

/**
 * Shared link renderer for the desktop and mobile Dark Gloomy Art navigation.
 */
export const DarkGloomyNavigationLink = props => {
  const { item, className, children } = props;
  const content = children || <FormattedMessage id={item.messageId} />;

  return item.routeName ? (
    <NamedLink className={className} name={item.routeName} params={item.params}>
      {content}
    </NamedLink>
  ) : (
    <ExternalLink className={className} href={item.href} target="_self">
      {content}
    </ExternalLink>
  );
};

export const isNavigationItemCurrent = (item, currentPage) => {
  if (!item.routeName) {
    return false;
  }
  if (item.routeName === 'CMSPage') {
    return currentPage === `CMSPage:${item.params?.pageId}`;
  }
  if (item.routeName === 'SearchPage') {
    return currentPage?.indexOf('SearchPage') === 0;
  }
  if (item.routeName === 'NewListingPage') {
    return ['NewListingPage', 'EditListingPage'].includes(currentPage);
  }
  return currentPage === item.routeName;
};
